import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'

interface SiteLayoutProps extends LayoutProps {
    tone?: 'light' | 'dark'
    hideFooter?: boolean
}

export const Layout: FC<SiteLayoutProps> = ({ children, tone = 'light', hideFooter = false }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main-content'
                className='sr-only z-50 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <SiteHeader tone={tone} />

            <main id='main-content' className='flex-1'>
                {children}
            </main>

            {!hideFooter && <SiteFooter />}
        </div>
    )
}
